import { LetterbookRowComponentType, LetterbookSettingType } from "../../types";
import {
  listRowComponents,
  libraryRowComponents,
  tagRowComponents,
  promptRowComponents,
  authorRowComponents,
  goalRowComponents,
  seriesRowComponents,
  publisherRowComponents,
  characterRowComponents,
} from "./contexts";

type RowGeneratorType = (
  settings: LetterbookSettingType
) => LetterbookRowComponentType;

const generator = {
  list: listRowComponents,
  library: libraryRowComponents,
  tag: tagRowComponents,
  prompt: promptRowComponents,
  goal: goalRowComponents,
  author: authorRowComponents,
  series: seriesRowComponents,
  publisher: publisherRowComponents,
  character: characterRowComponents,
};

// Returns the correct row component based on the type and view
export default function findRowComponent(
  settings: LetterbookSettingType
): LetterbookRowComponentType {
  const rowMap = generator[settings.type] as unknown as RowGeneratorType;
  return rowMap(settings);
}
